import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy-950 text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-272" data-mp="369pga49jt16e">
      <div className="metal-silver h-2 w-full" aria-hidden="true" data-id="element-273" data-mp="31jhe67m7cct4" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-274" data-mp="31h4pzcpup67m">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-silver-200" data-id="element-275" data-mp="3g7c6vo07mh67">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-276" data-mp="3b8itrwou4s6k" /> El precio de lanzamiento termina en:
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-277" data-mp="3p6pkmsvd9rwq" />
        <p className="mt-7 font-bold text-silver-200" data-id="element-278" data-mp="3l6ynm7f8yfjr">Después sube el precio y no vuelve a bajar.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-silver-400/30 bg-navy-800 p-4 text-left text-sm" data-id="element-279" data-mp="1uu0vnjjroe8r">
          <p className="flex items-center justify-between gap-3 font-bold" data-id="element-280" data-mp="1qurye4pipy8g">
            <span className="inline-flex items-center" data-id="element-281" data-mp="2suple04vztx8">
              <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-red-500" aria-hidden="true" data-id="element-282" data-mp="2srtq6jkfbjch" />
              Cupos al precio de lanzamiento
            </span>
            <span className="text-silver-200" data-id="element-283" data-mp="32pr9qtrc8ryr">Quedan pocos</span>
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-navy-950" data-id="element-284" data-mp="37k5alborrrat">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="metal-silver h-full rounded-full" data-id="element-285" data-mp="3cglxy3o5a1mu" />
          </div>
          <p className="mt-1 text-right text-xs text-silver-300" data-id="element-286" data-mp="3qgdfgedve05l">66% de los cupos tomados</p>
        </div>
      </div>
      <div className="metal-silver h-2 w-full" aria-hidden="true" data-id="element-287" data-mp="1r5vluggm80jg" />
    </section>;
}